import PropTypes from 'prop-types';
import responsiveDefinitions from "../../../../../hoc/ResponsiveDefinitions/ResponsiveDefinitions";

const ResponsiveImage = ({images, Styles, ...props}) => {
    if (Styles.isXXS && images.hasOwnProperty('xxs')) return images.xxs;
    if (Styles.isXS && images.hasOwnProperty('xs')) return images.xs;
    if (Styles.isSM && images.hasOwnProperty('sm')) return images.sm;
    if (Styles.isMD && images.hasOwnProperty('md')) return images.md;
    if (Styles.isLG && images.hasOwnProperty('lg')) return images.lg;
    if (Styles.isXLG && images.hasOwnProperty('xlg')) return images.xlg;

    return images.xlg
        || images.lg
        || images.md
        || images.sm
        || images.xs
        || images.xxs;
};

ResponsiveImage.propTypes = {
    images: PropTypes.shape({
        xxs: PropTypes.any,
        xs: PropTypes.any,
        sm: PropTypes.any,
        md: PropTypes.any,
        lg: PropTypes.any,
        xlg: PropTypes.any,
    }),
};

ResponsiveImage.defaultProps = {
    images: {
        xxs: null,
        xs: null,
        sm: null,
        md: null,
        lg: null,
        xlg: null,
    }
};

export default responsiveDefinitions(ResponsiveImage);